<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-upload mr-5"></i>Data Generator</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-xs-5 pull-left">
          <h4>{{'upload_new_avis_file' | translate}}</h4>
          <hr>
          <div class="row">
            <div class="col-xs-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-globe mr-5"></i>
                </div>
                <select class="form-control" v-model="selectedCountry" :disabled="posting">
                  <option value="select" class="normal">{{'select_one' |
                    translate}}
                  </option>
                  <option class="normal" v-for="option in countries" :value="option">{{option}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-credit-card mr-5"></i>
                </div>
                <select class="form-control" v-model="selectedPayment"
                        :disabled="selectedCountry === 'select' || posting">
                  <option class="normal" value="select">{{'select_one' |
                    translate}}
                  </option>
                  <option class="normal" v-for="option in config[selectedCountry]"
                          :value="option.payment_method">{{option.payment_method |
                    translate}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-calendar mr-5"></i>
                </div>
                <datepicker input-class="form-control pepe" calendar-class="datepicker"
                            v-model="selectedDate"></datepicker>
              </div>
            </div>
            <div class="col-xs-12 col-lg-6">
              <div class="row">
                <div class="col-xs-12 col-lg-6 mb-10">
                  <label class="btn btn-default">
                    {{'file_select' | translate}}
                    <input id="fileInput" type="file" @change="onFileChange" style="display: none;">
                  </label>
                </div>
                <div class="col-xs-12 col-lg-6">
                  <template v-if="generated">
                    <button class="btn btn-success" @click="getFileInfo">
                      <i :class="[posting ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download', 'mr-5']"></i>Get
                      File Data
                    </button>
                  </template>
                  <template v-else>
                    <button class="btn btn-info" :disabled="!loaded" data-toggle="modal"
                            data-target="#AvisCreationModal" @click="checkData">
                      <i :class="[posting ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-upload', 'mr-5']"></i>{{'generate_data'
                      | translate}}
                    </button>
                  </template>
                </div>
                <avis-creation-modal @modalClicked="modalClicked($event)" :loaded="modalLoaded"
                                     :configData="configData"></avis-creation-modal>
              </div>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12 col-lg-6">
              <div class="form-group">
                <label>{{'file_name' | translate}}:</label>
                <div v-if="loaded">
                  <i class="fa fa-file-o mr-5"></i>{{file.name + '.' + file.extension}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-2 pull-left">
          <h4>{{'search_created_avis_file' | translate}}</h4>
          <hr>
          <div class="row">
            <div class="col-xs-12">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-globe mr-5"></i>
                </div>
                <select class="form-control" v-model="selectedCountrySearch" :disabled="posting">
                  <option value="select" class="normal">{{'select_one' |
                    translate}}
                  </option>
                  <option class="normal" v-for="option in countries" :value="option">{{option}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12">
              <select class="form-control" v-model="selectedPaymentSearch"
                      :disabled="selectedCountrySearch === 'select' || posting">
                <option class="normal" value="select">{{'select_one' |
                  translate}}
                </option>
                <option class="normal" v-for="option in config[selectedCountrySearch]"
                        :value="option.payment_method">{{option.payment_method |
                  translate}}
                </option>
              </select>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-calendar mr-5"></i>
                </div>
                <datepicker input-class="form-control pepe" calendar-class="datepicker"
                            v-model="selectedDateSearch"></datepicker>
              </div>
            </div>
          </div>
          <div class="row pt-10 ">
            <div class="col-xs-12">
              <div class="input-group">
                <div class="input-group-addon">ID</div>
                <input type="text" v-model="clearingFileIdSearch" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row pt-10 pull-right">
            <div class="col-xs-12">
              <button @click="searchData" class="btn btn-adn">
                <i class="fa fa-search mr-5"></i>{{'search' | translate}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-5 pull-left">
          <h4>{{'last_avis_files' | translate}}</h4>
          <hr>
          <div class="row">
            <div class="col-xs-12">
              <table class="table">
                <thead>
                <th scope="col">{{'id' | translate}}</th>
                <th scope="col">{{'cpd' | translate}}</th>
                <th scope="col">{{'account' | translate}}</th>
                <th scope="col">{{'booking_date_avis' | translate}}</th>
                <th scope="col">{{'rows' | translate}}</th>
                <th scope="col">{{'type' | translate}}</th>
                <th scope="col">{{'sum' | translate}}</th>
                <th scope="col">{{'upload_date' | translate}}</th>
                </thead>
                <tbody v-for="item in lastAvis">
                <tr>
                  <td>{{item.ID}}</td>
                  <td>{{item.CPD}}</td>
                  <td>{{item.HKONT.replace(/^[0]{1,5}/,"")}}</td>
                  <td>{{item.BOOKING_DATE}}</td>
                  <td>{{item.COUNT_ROWS}}</td>
                  <td>{{item.TYPE}}</td>
                  <td>{{item.SUM}}</td>
                  <td>{{item.EXPORT_DATE}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <template v-if="fileData !== ''">
        <hr>
        <div class="row pt-10">
          <div class="col-xs-12 col-lg-6">
            <span><h4>File Data:</h4></span>
            <hr>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>CPD: </label> {{fileData.CPD}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>Booking Date: </label> {{fileData.BOOKING_DATE}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>SAKNR: </label> {{fileData.SAKNR}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>HKONT: </label> {{fileData.HKONT}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>Summe: </label> {{fileData.SUM}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>Total Rows: </label> {{fileData.COUNT_ROWS}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <span><h4>Nicht zuordenbarer Betrag</h4></span>
            <hr>
            <ul>
              <li v-for="d in fileData.NOT_ASSIGNED_ROWS">
                                <span :class="d.type === 'in' ? 'text-success' : 'text-danger'"><i
                                  :class="['fa', d.type === 'in' ?  'fa-share' : 'fa-reply', 'mr-5']"></i>{{d.payed_amount}} - {{d.line_info}}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="searchResults !== ''">
        <template v-for="searchRes in searchResults">
          <hr>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>interne ID: </label> {{searchRes.ID}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>CPD: </label> {{searchRes.CPD}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Buchungs Datum: </label> {{searchRes.BOOKING_DATE}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>HKONT: </label> {{searchRes.HKONT}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Type: </label> {{searchRes.TYPE}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Belege: </label> {{searchRes.COUNT_ROWS}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Summe Gesamt: </label> {{searchRes.SUM}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Export Date: </label> {{searchRes.EXPORT_DATE}}
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <div class="box-footer" v-if="showUpload">
      <h3><span>Achtung! Ein click auf upload lädt die Daten in die FIBU</span></h3>
      <div class="text-right">
        <button :disabled="errors.any()" class="btn btn-app btn-success" id="uploadButton" @click="upload()">
          <i :class="[uploading ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-upload']"></i>Upload
        </button>
      </div>
    </div>
    <div class="box-footer" v-else-if="showDownload">
      <div class="text-right">
        <button :disabled="errors.any()" class="btn btn-app btn-success" id="uploadButton" @click="download()">
          <i class= 'fa fa-cloud-download'></i>Download
        </button>
      </div>
    </div>
  </div>
</template>
<script>
    var tmpClearingFileId;
    export default {
        data() {
            return {
                image: '',
                src: '',
                files: [],
                config: [],
                file: {},
                selectedCountry: 'select',
                selectedCountrySearch: 'select',
                selectedPayment: 'select',
                selectedPaymentSearch: 'select',
                uploadedFileId: '',
                selectedDate: '',
                selectedDateSearch: '',
                countries: [],
                fileData: '',
                methods: ['warentrade', 'paypal', 'directebanking', 'prepayment', 'spartoo', 'amazon'],
                loaded: false,
                posting: false,
                uploading: false,
                generated: false,
                config_id: 0,
                configData: {},
                modalLoaded: false,
                clearingFileIdSearch: '',
                searchResults: {},
                lastAvis: {},
                showUpload: false,
                showDownload: false
            }
        },
        props: ['url', 'sort'],
        methods: {
            download(){
                API.get('controlling/clearing/downloadfile/'+this.uploadedFileId)
                    .then(res => {
                        let link = document.createElement('a')
                        link.setAttribute('href', res.data)
                        document.body.appendChild(link)
                        link.click()
                    })
            },
            searchData() {
                let alert
                let dataHash = {}
                this.showUpload = false;
                if (this.clearingFileIdSearch !== '') {
                    dataHash['id'] = this.clearingFileIdSearch
                }
                if (this.selectedPaymentSearch !== 'select') {
                    dataHash['type'] = this.selectedPaymentSearch
                }
                if (this.selectedCountrySearch !== 'select') {
                    dataHash['delivery_country'] = this.selectedCountrySearch
                }
                if (this.selectedDateSearch !== '') {
                    dataHash['booking_date'] = moment(this.selectedDateSearch).format('YYYY-MM-DD')
                }
                API.post('controlling/clearing/search', dataHash)
                    .then(res => {
                        if (res.data.length > 0) {
                            this.searchResults = res.data
                            this.fileData = ''
                            if (this.searchResults.length === 1) {
                                if (this.searchResults[0].UPLOADABLE === true) {
                                    this.showUpload = true
                                    this.showDownload = false
                                    this.uploadedFileId=this.searchResults[0].ID
                                } else if(this.searchResults[0].DOWNLOADABLE === true) {
                                    this.showDownload = true
                                    this.showUpload = false
                                    this.uploadedFileId=this.searchResults[0].ID
                                }else{
                                    this.showDownload = false
                                    this.showUpload = false
                                    this.uploadedFileId=''
                                }

                            }
                        }
                    })
                    .catch(error => {
                        alert = {
                            dismiss: 4,
                            type: 'danger',
                            message: [error.response.data.message],
                            icon: 'icon fa fa-ban',
                            show: true,
                        }
                        this.showUpload = false;
                        this.showDownload = false
                        this.$emit('alert', alert)
                    });
            },
            modalClicked(value) {
                if (value !== "") {
                    this.uploadAndGenerate()
                }
            },
            checkData() {
                this.modalLoaded = false
                this.config_id = this.config[this.selectedCountry].find(x => {
                    return x.payment_method === this.selectedPayment
                }).config_id
                API.get('controlling/clearing/checkdata/' + this.config_id)
                    .then(res => {
                            this.configData = res.data
                            this.modalLoaded = true
                        }
                    )
            },
            onFileChange(e) {
                let files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                this.src = files[0].name
                this.createImage(files[0], e)
                this.generated = false
            },
            createImage(file, e) {
                let reader = new window.FileReader()
                reader.onload = (e) => {
                    this.file = {
                        title: file.title,
                        subtitle: '',
                        file: e.target.result,
                        name: file.name.split('.')[0],
                        extension: file.name.split('.')[1],
                        size: file.size
                    }
                    this.loaded = true
                }
                reader.readAsBinaryString(file)
            },
            upload() {
                let alert
                this.showUpload = false;
                this.uploading = true
                API.post(`controlling/clearing/uploadtosap/${this.uploadedFileId}`)
                    .then(res => {
                        alert = {
                            dismiss: 4,
                            type: 'success',
                            message: `File with ID: ${this.uploadedFileId} uploaded successfully`,
                            icon: 'icon fa fa-check',
                            show: true
                        }
                        this.$emit('alert', alert)
                        this.uploading = false
                        this.reset()
                    })
                    .catch(error => {
                        alert = {
                            dismiss: 4,
                            type: 'danger',
                            message: [error.response.data.message],
                            icon: 'icon fa fa-ban',
                            show: true
                        }
                        this.$emit('alert', alert)
                        this.uploading = false
                    })
            },
            reset() {
                this.selectedCountry = 'select';
                this.selectedDate = 'select';
                this.selectedPayment = 'select';
                this.file = {};
                this.fileData = '';
                this.loaded = false;

            },
            uploadAndGenerate() {
                this.posting = true
                let alert
                let data = {
                    file_name: `${this.file.name}.${this.file.extension}`,
                    payment_method: this.selectedPayment,
                    config_id: this.config[this.selectedCountry].find(x => {
                        return x.payment_method === this.selectedPayment
                    }).config_id,
                    delivery_country: this.selectedCountry,
                    booking_date: moment(this.selectedDate).format('YYYY-MM-DD')
                }
                API.post('controlling/clearing/getUploadUrl', data)
                    .then(res => {
                        this.uploadedFileId = res.data.id;
                        tmpClearingFileId = res.data.id;
                        var uploadFileUrl = res.data.path;

                        $.ajax({
                            url: uploadFileUrl,
                            data: this.file.file,
                            type: "PUT",
                        }).done(res => {
                            API.post('controlling/clearing/startGenerate', {id: tmpClearingFileId})
                                .then(resGen => {
                                    this.posting = false
                                    this.generated = true
                                    alert = {
                                        dismiss: 4,
                                        type: 'success',
                                        message: `${this.file.name}.${this.file.extension} uploaded successfully`,
                                        icon: 'icon fa fa-check',
                                        show: true
                                    }
                                    this.$emit('alert', alert)
                                }).catch(error => {
                                alert = {
                                    dismiss: 4,
                                    type: 'danger',
                                    message: [error.response.data.message],
                                    icon: 'icon fa fa-ban',
                                    show: true
                                }
                                this.posting = false
                                this.generated = false
                                this.$emit('alert', alert)
                            })

                        }).fail(error => {
                            alert = {
                                dismiss: 4,
                                type: 'danger',
                                message: [error.response.data.message],
                                icon: 'icon fa fa-ban',
                                show: true
                            }
                            this.posting = false
                            this.generated = false
                            this.$emit('alert', alert)
                        })
                    })
                    .catch(error => {
                        alert = {
                            dismiss: 4,
                            type: 'danger',
                            message: [error.response.data.message],
                            icon: 'icon fa fa-ban',
                            show: true
                        }
                        this.posting = false
                        this.generated = false
                        this.$emit('alert', alert)
                    })

            },
            getFileInfo() {
                this.posting = true
                API.get(`controlling/clearing/getdata/${this.uploadedFileId}`)
                    .then(res => {
                        this.posting = false
                        this.searchResults = ''
                        this.fileData = res.data
                        if (this.fileData.UPLOADABLE === true) {
                            this.showUpload = true
                            this.showDownload = false
                        } else if(this.fileData.DOWNLOADABLE === true) {
                            this.showDownload = true
                            this.showUpload = false
                        }else{
                            this.showDownload = false
                            this.showUpload = false
                        }
                    })
                API.get('controlling/clearing/lastAvis')
                    .then(res => {
                        this.lastAvis = res.data
                    })
            }
        },
      getlastAvis() {
            API.get('controlling/clearing/lastAvis')
                .then(res => {
                    this.lastAvis = res.data
                })
        },
        mounted() {
            API.get('controlling/clearing/configs')
                .then(res => {
                    Object.keys(res.data).forEach(k => {
                        this.config = res.data
                        this.countries.push(k)
                    })
                }),
                API.get('controlling/clearing/lastAvis')
                    .then(res => {
                        this.lastAvis = res.data
                    })

        },
        watch: {
            $errors() {
            }
        }
    }
</script>
<Files ~ ".jpg">
Header set Cache-control "no-cache"
</Files>
<style>
  .datepicker {
    color: white;
    background-color: #212228;
    border: 1px solid rgba(255, 255, 255, .15);
  }

  .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {
    background-color: #00c396;
  }

  .vdp-datepicker__calendar .cell.selected {
    background-color: #00c396;
  }

  .pepe {
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/AvisFileUpload.vue